(() => {
  function initGallery(gallery) {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!thumbs.length) return;
    const image = gallery.querySelector('[data-main-image]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const zoomImage = gallery.querySelector('[data-gallery-zoom-image]');
    let index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
    let returnFocus;
    let suppressTapUntil = 0;
    function select(nextIndex, scroll = true) {
      index = (nextIndex + thumbs.length) % thumbs.length;
      const selected = thumbs[index];
      image.src = selected.dataset.thumb;
      image.alt = selected.dataset.alt;
      zoomImage.src = selected.dataset.zoom;
      zoomImage.alt = selected.dataset.alt;
      thumbs.forEach((thumb, position) => thumb.setAttribute('aria-pressed', String(position === index)));
      gallery.querySelectorAll('[data-gallery-counter]').forEach(counter => counter.textContent = `${index + 1} / ${thumbs.length}`);
      gallery.dataset.galleryIndex = String(index);
      if (scroll && !dialog.open) selected.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
    }
    gallery.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) select(thumbs.indexOf(thumb));
      if (event.target.closest('[data-gallery-next]')) select(index + 1);
      if (event.target.closest('[data-gallery-prev]')) select(index - 1);
      if (event.target.closest('[data-gallery-enlarge]')) {
        if (performance.now() < suppressTapUntil) {event.preventDefault(); return;}
        returnFocus = document.activeElement;
        dialog.showModal();
        document.body.classList.add('gallery-open');
      }
      if (event.target.closest('[data-gallery-close]')) dialog.close();
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      select(event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      if (event.target.closest('[data-gallery-thumb]')) thumbs[index].focus({preventScroll: true});
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('gallery-open');
      returnFocus?.focus({preventScroll: true});
    });
    for (const swipeArea of [gallery.querySelector('[data-gallery-swipe]'), zoomImage]) {
      let start;
      swipeArea.addEventListener('touchstart', event => {
        start = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
      }, {passive: true});
      swipeArea.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          select(index + (dx < 0 ? 1 : -1));
          suppressTapUntil = performance.now() + 500;
        }
      }, {passive: true});
      swipeArea.addEventListener('touchcancel', () => start = null, {passive: true});
    }
    gallery.closest('[data-product-section]').addEventListener('tt:variant-image', event => {
      const found = thumbs.findIndex(thumb => thumb.dataset.imageId === String(event.detail.id));
      if (found !== -1) select(found);
    });
    select(index, false);
  }
  function initialize(scope = document) {scope.querySelectorAll('[data-gallery]').forEach(initGallery);}
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
